import { Resource } from '@core';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import * as styles from './postMerchantWidgetItem.module.css';

interface Props extends StyleProps {
  merchant: Resource;
}

export const PostMerchantsWidgetItem: FC<Props> = ({ className, merchant }) => {
  const { merchantName, webDescription, webLink, webImage } = merchant;
  return (
    <a
      className={mc('h-[245px] md:h-[300px]', 'flex flex-col', 'block rounded-2xl overflow-hidden', 'bg-white', className)}
      href={webLink}
      target="__blank"
    >
      <div
        className={mc(
          'h-28 basis-28 grow-0 shrink-0',
          'p-3',
          'flex justify-center items-center',
          'bg-white',
          'border-b border-b-gray-500/20',
        )}
      >
        <div
          className={mc('w-full h-full', 'bg-white bg-no-repeat bg-center bg-contain')}
          style={{ backgroundImage: `url(${webImage?.url})` }}
        />
      </div>
      <div className={mc('px-4 py-4', 'flex-1', 'flex flex-col')}>
        <div className={mc('text-xl font-raleway leading-normal font-bold text-ocean-blue')}>{merchantName}</div>
        <div className={mc('mt-0.5', 'flex-1', 'text-sm font-raleway leading-normal font-medium text-ocean-blue')}>
          <div className={styles.description}>{webDescription}</div>
        </div>
      </div>
    </a>
  );
};

export type PostMerchantsWidgetItemProps = Props;
export default PostMerchantsWidgetItem;
